<script>
import SearchResultsTab from '@phoenix/mixins/components/search/SearchResultsTab';

export default {
  mixins: [SearchResultsTab],

  watch: {
    isLoading: {
      handler(value) {
        this.setButtonLoading(value);
      },
    },
  },

  mounted() {
    if (this.isLoading) {
      this.setButtonLoading();
    }
  },

  methods: {
    setButtonLoading(isLoading = true) {
      if (isLoading) {
        Toolkit.helpers.buttons.addLoadingState(this.$refs.loadMoreButton);
      } else {
        Toolkit.helpers.buttons.removeLoadingState(this.$refs.loadMoreButton);
      }
    },
  },
};
</script>

<template>
  <section v-if="hasResults || !hasLimit" class="section">
    <slot />

    <div v-if="displayLoadMore" class="text-center mt-base">
      <button ref="loadMoreButton" type="button" class="btn btn--default btn--loading" @click="onLoadMoreClick">
        <span class="btn__text">{{ $t('Button.loadMore') }}</span>
      </button>
    </div>
  </section>
</template>
